module.exports = __webpack_public_path__ + "img/kt4.eba2b6c1.png";